import { Icon, makeStyles } from '@rneui/themed'
import React from 'react'
import { ActivityIndicator } from 'react-native'

interface Props {
  direction: 'left' | 'right'
  disabled?: boolean
  loading: boolean
  onPress: () => void
}

export function WeekSelector(props: Props) {
  const styles = useStyles()

  if (props.loading) {
    return <ActivityIndicator style={styles.container} />
  }

  return (
    <Icon
      onPress={props.onPress}
      containerStyle={styles.container}
      color={styles.icon.color}
      type="font-awesome-5"
      name={`angle-${props.direction}`}
      disabled={props.disabled}
      disabledStyle={styles.disabled}
      solid
    />
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    width: 25,
  },
  icon: {
    color: theme.colors?.grey2,
  },
  disabled: {
    width: 0,
    height: 0,
  },
}))
